import React, { useEffect } from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";

import "./AvenueMalls.scss";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer2 from "../../component/footer/Footer2";
import ImageGallery from "../../component/ImageGallery/ImageGallery";
import { formatIndianNumber } from "../../utils/common";
// import Footer from "../../component/footer/Footer2"
import ratingIcon from "../../assets/images/ratingIcon.svg";
import Clock from "../../assets/images/clock.svg";
import gold_rupe_icon_lg from "../../assets/images/gold_rupe_md.svg";
import storeLocator from "../../assets/images/locationpin.svg";
import rigthIcon from "../../assets/images/rigthIconline.svg";
// import callIcon from "../../assets/images/phoneIcon.svg";
// import rigthArrow from "../../assets/images/lineRigtharrow.svg";
import CarIcon from "../../assets/images/carImg.svg";
import arrow from "../../assets/images/arrow.svg";
// import uberIcon from "../../assets/images/uber.svg";
// import olaIcon from "../../assets/images/ola.svg";
// import blusmartIcon from "../../assets/images/blusmart.svg";
import ArrowWhite from "../../assets/images/LineWhiteArrow.svg";
// import dlfImg1 from "../../assets/images/mall1.svg"
// import dlfImg2 from "../../assets/images/mall2.svg";
// import dlfImg3 from "../../assets/images/mall3.svg";
// import dlfImg4 from "../../assets/images/mall4.svg";
import phoneIocn from "../../assets/images/phoneIcon.svg";
// import event1 from "../../assets/images/event1.svg";
// import event2 from "../../assets/images/event2.svg";
// import event3 from "../../assets/images/event3.svg";
// import event4 from "../../assets/images/event4.svg";
// import event5 from "../../assets/images/5.svg";
import cab_mob from "../../assets/images/cab_mob_img.png";
// import avenuMallimg from "../../assets/images/avenueMallImg.svg";
import insta_icon from "../../assets/images/instagram_line.svg";
import yt_icon from "../../assets/images/youtube_line.svg";
import { fetchMalls } from "../../redux/slice/malls/malls";

const AvenueMalls = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const mallData = location?.state?.data;
  const {
    mall_description,
    Additional_Details,
    Events,
    Banner,
    mall_name,
    mall_image,
  } = mallData?.attributes;
  const thumbnailImage = mall_image?.data?.attributes?.formats?.thumbnail?.url;
  const { mallsData } = useSelector((state) => state.malls);
  const { customerDetailsData } = useSelector((state) => state.customerDetails);
  const dispatch = useDispatch();
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
      onClick={() => navigate("/dlf-malls")}
    >
      DLF Malls
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      DLF Avenue Saket
    </Typography>,
  ];

  const getValue = (data, type, returnValue = "") => {
    if (data?.length > 0) {
      const result = data?.find((item) => item.type === type);
      if (returnValue?.length > 0) {
        return result[returnValue];
      } else {
        return result;
      }
    }
  };
  const socialData = getValue(Additional_Details?.data, "Social_link");
  const mallAddress = getValue(
    Additional_Details?.data,
    "Location",
    "subtitle"
  );
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    mallAddress
  )}`;

  useEffect(() => {
    dispatch(fetchMalls());
  }, []);
  return (
    <>
      <Header />
      <div className="home">
        <div className="container pt-5 bread">
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar pt-5 in-mobile">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside />
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-pointHistory"
                        role="tabpanel"
                        aria-labelledby="v-pills-pointHistory-tab"
                        tabIndex="0"
                      >
                        <div className="home">
                          <div className="tab_content">
                            <div
                              className="tab-content"
                              id="v-pills-tabContent"
                            >
                              <div className="mallpage">
                                <div className="mall_descriptions">
                                  <div className="row">
                                    <div className="col-lg-8 col-md-8 border-1">
                                      <div className="heading">
                                        <h1>{mall_name}</h1>
                                      </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 desktop_content">
                                      <div className="ratedInfo">
                                        <div className="topRating">
                                          <img src={ratingIcon} alt="" /> Top
                                          Rated
                                        </div>
                                      </div>
                                    </div>
                                    <div className="mallImage-cont">
                                      <img
                                        src={`https://d3kj4cuhkbykh5.cloudfront.net${thumbnailImage}`}
                                        alt=""
                                        width="100%"
                                        className="mallimg_mob"
                                      />
                                    </div>
                                  </div>
                                  <p>{mall_description}</p>
                                </div>
                                {/* <ImageGallery mall_image={mall_image} /> */}
                                <div className="mallInfo">
                                  <div className="layout">
                                    <div
                                      className="row"
                                      style={{ backgroundColor: "white" }}
                                    >
                                      <div className="col-lg-7 col-md-6">
                                        <div>
                                          <h5>Location</h5>
                                          <div className="d-flex layout_item">
                                            <div className="">
                                              <img
                                                className="storelocator"
                                                src={storeLocator}
                                                alt=""
                                              />
                                            </div>
                                            <p>
                                              <a
                                                href={googleMapsLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                              >
                                                {mallAddress}
                                              </a>
                                            </p>
                                          </div>
                                          <h5 className="layout2Heading">
                                            Timings
                                          </h5>
                                          <div className="d-flex layout_item">
                                            <div className="">
                                              <img
                                                className="storelocator iconClocl"
                                                src={Clock}
                                                alt=""
                                              />
                                            </div>
                                            <p>
                                              {getValue(
                                                Additional_Details?.data,
                                                "Timings",
                                                "subtitle"
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="col-lg-5 col-md-6">
                                        <div className="cards">
                                          <div className="card-item">
                                            <h1>
                                              Transfer Loyalty Points with
                                              Friends & Family
                                            </h1>
                                            <p>
                                              Points Expiring till 24 Jan 2025
                                            </p>
                                          </div>
                                          <div className="d-flex pointsRow">
                                            <p className="points">
                                              {
                                                customerDetailsData?.loyalty_points
                                              }
                                              <img
                                                src={gold_rupe_icon_lg}
                                                alt=""
                                              />
                                            </p>
                                            <div
                                              className="button_container "
                                              onClick={() =>
                                                navigate("/friends-family")
                                              }
                                            >
                                              <div className="d-flex">
                                                <div className="reddemPoint_exclusive">
                                                  Share Points{" "}
                                                  <img src={arrow} alt="" />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div> */}
                                    </div>
                                  </div>
                                  <div className="map-layout">
                                    <div className="row">
                                      <div className="col-lg-7 col-md-7">
                                        <div>
                                          <h5>More Info</h5>
                                          <div
                                            style={{
                                              display: "grid",
                                              gridTemplateColumns: "1fr 1fr",
                                            }}
                                          >
                                            {getValue(
                                              Additional_Details?.data,
                                              "More Info",
                                              "details"
                                            ).map((item) => {
                                              return (
                                                <React.Fragment key={item}>
                                                  <div
                                                    className="d-flex align-items-center lists"
                                                    style={{ width: "100%" }}
                                                  >
                                                    <div
                                                      className="d-flex layout_item list"
                                                      style={{ width: "100%" }}
                                                    >
                                                      <div className="">
                                                        <img
                                                          className="storelocator"
                                                          src={rigthIcon}
                                                          alt=""
                                                        />
                                                      </div>
                                                      <p>{item}</p>
                                                    </div>
                                                  </div>
                                                </React.Fragment>
                                              );
                                            })}
                                          </div>
                                        </div>
                                        <div className="peoplesuggestion">
                                          <h5>
                                            People Say This Place Is Known For
                                          </h5>
                                          <p>
                                            {getValue(
                                              Additional_Details?.data,
                                              "People Say This Place Is Known For",
                                              "subtitle"
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                      {/* <div className="col-lg-5 col-md-5">
                                        <div className="cards">
                                          <h1>Mall Direction</h1>
                                          <p>
                                            {getValue(
                                              Additional_Details?.data,
                                              "Location",
                                              "subtitle"
                                            )}
                                          </p>
                                          <div className="buttons">
                                            <button>
                                              <img src={callIcon} alt="" /> Call
                                            </button>
                                            <button>
                                              <img src={rigthArrow} alt="" />
                                              Direction
                                            </button>
                                          </div>
                                        </div>
                                      </div> */}
                                      <div className="col-lg-5 col-md-5">
                                        <div className="cards socials">
                                          <h1>{socialData?.tittle}</h1>
                                          <div className="buttons">
                                            <a
                                              href={socialData?.Instagram}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <img
                                                src={insta_icon}
                                                alt="insta icon"
                                              />
                                            </a>
                                            {/* <a
                                              href={socialData?.Youtube}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              <img
                                                src={yt_icon}
                                                alt="youtube icon"
                                              />
                                            </a> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="expire_sec transferPoint  bookingSection desktop_content">
                                  <div>
                                    <img src={CarIcon} alt="" />
                                  </div>
                                  <div className="bookingContent">
                                    <h1>Book a cab to {mall_name}</h1>
                                    <p>
                                      Make your ride easy with our driving
                                      partners in just a click{" "}
                                    </p>
                                    <div className="cabInfo d-flex gap-4 pt-4">
                                      {Banner?.data[0]["additional details"]
                                        ?.length > 0 ? (
                                        <>
                                          {Banner?.data[0][
                                            "additional details"
                                          ]?.map((item,index) => {
                                            return (
                                              <a
                                                href={item?.deeplink}
                                                style={{
                                                  textDecoration: "none",
                                                  color: "inherit",
                                                }}
                                                key={index}
                                                target="_blank"
                                                rel="noreferrer"
                                              >
                                                <div className="d-flex align-items-center gap-2 cab_list">
                                                  <img
                                                    src={item?.image}
                                                    alt=""
                                                  />
                                                  {parse(item?.desctiption)}
                                                  <a
                                                    href={item?.deeplink}
                                                    style={{
                                                      textDecoration: "none",
                                                    }}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                  >
                                                    <img
                                                      src={ArrowWhite}
                                                      alt=""
                                                    />
                                                  </a>
                                                </div>
                                              </a>
                                            );
                                          })}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="expire_sec transferPoint  bookingSection   bookingSection_mob mobile_content">
                                  <div>
                                    <img src={cab_mob} alt="" width={"100%"} />
                                  </div>
                                  <div className="bookingContent">
                                    <h1>Book a cab to DLF Avenue</h1>
                                    <p>
                                      Make your ride easy with our driving
                                      <br /> partners in just a click{" "}
                                    </p>
                                    <div className="cabInfo d-flex gap-4">
                                      {Banner?.data[0]["additional details"]
                                        ?.length > 0 ? (
                                        <>
                                          {Banner?.data[0][
                                            "additional details"
                                          ]?.map((item) => {
                                            return (
                                              <>
                                                <div className="d-flex align-items-center gap-2 cab_list">
                                                  <img
                                                    src={item?.image}
                                                    alt="logo"
                                                  />
                                                  <b>
                                                    {
                                                      parse(
                                                        item?.desctiption
                                                      )?.[1]?.props?.children
                                                    }
                                                  </b>
                                                  <a
                                                    href={item?.deeplink}
                                                    style={{
                                                      textDecoration: "none",
                                                    }}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                  >
                                                    <img
                                                      src={ArrowWhite}
                                                      alt="arroe white"
                                                    />
                                                  </a>
                                                </div>
                                              </>
                                            );
                                          })}
                                        </>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className="eventSection">
                                 {Events?.data?.length > 0 && <div className="heading">
                                    <h1>Events Available</h1>
                                  </div>}

                                  {Events?.data?.length > 0 ? (
                                    <>
                                      <div className="eventsbox">
                                        <div className="event">
                                          <div className="d-flex flex-wrap">
                                            {Events?.data?.map((item) => {
                                              return (
                                                <>
                                                  <div className="event-box col-lg-4 col-md-6 col-6">
                                                    <img
                                                      className="eventimg"
                                                      src={item?.bgImage}
                                                      alt=""
                                                    />
                                                    <div className="mall_description">
                                                      <p className="date">
                                                        {item?.Description}
                                                      </p>
                                                      <h6 className="title">
                                                        {item?.tittle}
                                                      </h6>
                                                      <div className="d-flex description">
                                                        <p>{item?.Store}</p>
                                                        <li>
                                                          ₹{formatIndianNumber(item?.Price)} onwards
                                                        </li>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              );
                                            })}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </div>

                                {mallsData?.length > 1 ? (
                                  <>
                                    <div className="d-flex flex-wrap moredlfMall">
                                      {mallsData
                                        ?.filter(
                                          (el) => el?.id !== mallData?.id
                                        )
                                        .map((item) => {
                                          const {
                                            mall_name,
                                            mall_image,
                                            Additional_Details,
                                            phone_number,
                                          } = item?.attributes;
                                          const thumbnailImage =
                                            mall_image?.data?.attributes
                                              ?.formats?.thumbnail?.url;
                                          return (
                                            <>
                                              <div className="malls-box col-lg-4 col-12">
                                                <img
                                                  className="mallimg"
                                                  src={`https://d3kj4cuhkbykh5.cloudfront.net${thumbnailImage}`}
                                                  alt=""
                                                  width={238}
                                                  height={164}
                                                  style={{ objectFit: "cover" }}
                                                />
                                                <div className="mall_description">
                                                  <h6>{mall_name}</h6>
                                                  <div className="d-flex align-items-center">
                                                    <div className="">
                                                      <img
                                                        className="storelocator"
                                                        src={storeLocator}
                                                        alt=""
                                                      />
                                                    </div>
                                                    <p>
                                                      {getValue(
                                                        Additional_Details?.data,
                                                        "Location",
                                                        "subtitle"
                                                      )}
                                                    </p>
                                                  </div>
                                                  {phone_number && <div className="d-flex phone_row align-items-center">
                                                    <div className="">
                                                      <img
                                                        className="storelocator"
                                                        src={phoneIocn}
                                                        alt=""
                                                      />
                                                    </div>

                                                    <p>
                                                      <a
                                                        href={`tel:${phone_number}`}
                                                        style={{
                                                          textDecoration:
                                                            "none",
                                                          color: "inherit",
                                                        }}
                                                        onClick={(e) =>
                                                          e.stopPropagation()
                                                        }
                                                      >
                                                        {phone_number}
                                                      </a>
                                                    </p>
                                                  </div>}
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                    </div>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer2 />
    </>
  );
};

export default AvenueMalls;
